import React, { useEffect, useRef, useState } from 'react';
import styles from "./mobilelogin2style.module.css";
import { useLocation } from 'react-router';
import { Capacitor } from "@capacitor/core";
import { Preferences } from "@capacitor/preferences";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet"
import { Diversity2Outlined } from '@mui/icons-material';
import { ReactComponent as LogoSvg } from '../../svg/newlogo.svg';
import { Button, TextField } from '@mui/material';
import { IonLoading } from '@ionic/react';
import { postFetch } from '../../fetch/fetch';


const MobileLogin2: React.FC<any> = (props) => {

    const headerRef = useRef<HTMLDivElement>(null);
    const [bodyHeight, setBodyHeight] = useState<number>(0);
    const [phoneNumber, setPhoneNumber] = useState("010");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [disabled, setDisabled] = useState(true);
    const [showLoading, setShowLoading] = useState(false);

    const inputRef1 = useRef<HTMLInputElement>(null);
    const inputRef2 = useRef<HTMLInputElement>(null);

    const location = useLocation<any>();

    useEffect(() => {
        const img = new Image();
        img.src = "/img/appdashboard.webp";
    }, []);

    useEffect(() => {

        //폰번호가 13자리, 비밀번호 4자리 이상일때만 활성화
        if (phoneNumber.replace(/-/g, "").length === 11 && password.length >= 4) {
            setDisabled(false);
        } else {
            setDisabled(true);
        }

    }, [phoneNumber, password]);


    //폰번호가 13자리면 자동으로 비밀번호 input으로 포커스 이동
    useEffect(() => {
        if (phoneNumber.replace(/-/g, "").length === 11) {
            if (inputRef2 && inputRef2.current) {
                inputRef2.current.focus();
            }
        }
    }, [phoneNumber]);

    //로그인 창 처음 들어왔을때 토큰 있는지 확인해서 있으면 로그인창 스킵하고 바로 대시보드로 보내는 기능-----------
    useEffect(() => {

        setShowLoading(true);

        var bool = true;

        if (location.state) {
            if (location.state.from === "dashboard") {
                bool = false;
            }
        }

        async function send() {
            //일렉트론 이라면 토큰 가져오는 기능------------------------------------------------------
            var token: any = ""

            if (window.electron) {

                token = await window.electron.sendMessageApi.getToken();
            }
            //-------------------------------------------------------------------------------------

            //네이티브 라면 토큰 가져오는 기능
            if (Capacitor.isNativePlatform()) {
                const { value } = await Preferences.get({ key: "token" });

                token = value;
            }


            // token = ipcRenderer.sendSync("getToken");

            fetch("https://peetsunbae.com/login/start", {
                method: "GET",
                headers: { "Authorization": token },
                credentials: "include"
            }).then((response) => {
                response.json()
                    .then((result) => {
                        setShowLoading(false);
                        console.log(result);
                        if (result.message === "LOGIN") {
                            props.history.push("/mobiledashboard");
                        }
                    })
            })
        }

        if (bool) {
            send();
        }else{
            setShowLoading(false);
        }
    }, [])
    //------------------------------------------------------------------------------------------------------

    useEffect(() => {

        if (!headerRef || !headerRef.current) return;


        const caculateBodyHeight = () => {

            if (!headerRef || !headerRef.current) return;

            const totalHeight = window.innerHeight;
            const headerHeight = headerRef.current.offsetHeight;

            const lastHeight = totalHeight - headerHeight;
            setBodyHeight(lastHeight);
        }

        const calculateBodyHeightAfterDelay = () => {

            setTimeout(() => {

                caculateBodyHeight();

            }, 50)

        }

        calculateBodyHeightAfterDelay();


        window.addEventListener("resize", calculateBodyHeightAfterDelay);

        return () => window.removeEventListener("resize", calculateBodyHeightAfterDelay);

    }, [headerRef]);

    const controlChange = (raw: string) => {
        // 1. 숫자만 남기기
        let digits = raw.replace(/\D/g, "");

        // 2. 앞 3자리는 무조건 010 유지
        if (!digits.startsWith("010")) {
            // 지우려고 해서 0, 01 이런 상태가 되면 그냥 010으로 고정
            if (digits.length <= 3) {
                digits = "010";
            } else {
                // 앞자리를 바꾸려 해도 010으로 강제
                digits = "010" + digits.slice(3);
            }
        }

        // 안전장치: 최소 010은 유지
        if (digits.length < 3) {
            digits = "010";
        }

        // 3. 총 숫자 갯수 제한 (010-1234-5678 => 11자리)
        if (digits.length > 11) {
            digits = digits.slice(0, 11);
        }

        // 4. 자리수에 따라 하이픈 붙이기/빼기
        let formatted = "";
        if (digits.length <= 3) {
            // 010
            formatted = digits;
        } else if (digits.length <= 7) {
            // 010-1 ~ 010-1234
            formatted = digits.slice(0, 3) + "-" + digits.slice(3);
        } else {
            // 010-1234-5 ~ 010-1234-5678
            formatted =
                digits.slice(0, 3) + "-" + digits.slice(3, 7) + "-" + digits.slice(7);
        }

        setPhoneNumber(formatted);
    };

    const submit = async () => {

        console.log("자동 로그인 시도", phoneNumber, password);

        if (!phoneNumber || !password) {
            alert("자동 로그인에 필요한 정보가 부족합니다. 다시 시도해주세요.");
            return;
        }

        try {

            console.log("자동 로그인 시작");

            setLoading(true);

            const result: any = await postFetch("/login/loginbyphonenumber", {
                phoneNumber,
                password
            });

            console.log(result);

            setLoading(false);

            if (result.message === "noPhoneNumber") {
                alert("등록된 휴대폰 번호가 아닙니다.");
                return;
            }

            if (result.message === "notNow") {
                alert("재원생 승인 후 가능합니다.");
                return;
            }

            if (result.message === "fail") {
                alert("잘못된 비밀번호입니다. 다시 시도해주세요.");
                return;
            }

            if (result.message === "success") {

                const isMultiple = result.isMultiple;

                if (!isMultiple) {

                    if (window.electron) {
                        const returnValue = window.electron.sendMessageApi.setToken(result.token);
                    }

                    if (Capacitor.isNativePlatform()) {

                        const token = result.token;

                        await Preferences.set({
                            key: "token",
                            value: token
                        })
                    }

                    props.history.push("/mobiledashboard");

                } else {

                    const accounts = result.accounts;

                    props.history.push({
                        pathname: "/multipleuserlogin",
                        state: {
                            phoneNumber,
                            users: accounts,
                            password
                        }
                    })

                }



            } else {
                alert("로그인에 실패했습니다. 다시 시도해주세요.");
            }

        } catch (e) {
            console.error(e);
        }


    }


    return (
        <div>
            <Helmet>
                <meta name="viewport" content="initial-scale=1, maximum-scale=1, user-scalable=no, width=device-width, viewport-fit=cover" />
            </Helmet>
            <div>
                <div style={{
                    paddingTop: "var(--safe-area-inset-top)"
                }} ref={headerRef} className={styles.header} />

                <div style={{
                    height: bodyHeight + "px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    alignItems: "center",
                    paddingTop: "100px",
                    // paddingBottom: "39px",
                    paddingBottom : "max(var(--safe-area-inset-bottom), 39px)",
                    width: "85%",
                    margin: "0 auto",
                }}>

                    <div className={styles.inputscontainer} style={{
                        width: "100%"
                    }}>
                        <div className={styles.logocontainer} style={{
                            marginBottom: "88px",
                            display: "flex",
                            justifyContent: "center"
                        }}>
                            <LogoSvg className={styles.logo} />
                        </div>
                        <div style={{
                            marginBottom: "30px"
                        }}>
                            <div className={styles.inputLabel}>
                                휴대폰 번호
                            </div>
                            <div>
                                <TextField
                                    variant="standard"
                                    placeholder='휴대폰 번호를 입력해주세요'
                                    fullWidth
                                    type="tel"
                                    sx={{
                                        "& .MuiInput-underline::before": {
                                            borderBottom: "1px solid #d3d3d3"
                                        },
                                        "& .MuiInput-underline": {
                                            height: "40px"
                                        },
                                        "& .MuiInputBase-input::placeholder": {
                                            fontFamily: "Apple_SB",
                                            color: "#d3d3d3"
                                        }
                                    }}
                                    value={phoneNumber}
                                    onChange={(e) => controlChange(e.target.value)}
                                    inputRef={inputRef1}
                                />
                            </div>
                        </div>
                        <div>
                            <div className={styles.inputLabel}>
                                비밀번호
                            </div>
                            <div>
                                <TextField
                                    variant="standard"
                                    placeholder='비밀번호를 입력해주세요'
                                    fullWidth
                                    type="password"
                                    sx={{
                                        "& .MuiInput-underline::before": {
                                            borderBottom: "1px solid #d3d3d3"
                                        },
                                        "& .MuiInput-underline": {
                                            height: "40px"
                                        },
                                        "& .MuiInputBase-input::placeholder": {
                                            fontFamily: "Apple_SB",
                                            color: "#d3d3d3"
                                        }
                                    }}
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    inputRef={inputRef2}
                                />
                            </div>
                        </div>
                        <div className={styles.buttonscontainer}>
                            <div>
                                <Button
                                    variant="contained"
                                    sx={{
                                        backgroundColor: "#3d50b0",
                                        height: "52px",
                                        borderRadius: "13px",
                                        fontWeight: 500,
                                        fontFamily: "Apple_R",
                                        boxShadow: "none !important",
                                        '&.Mui-disabled': {
                                            backgroundColor: '#C1d6f3',
                                            color: "white"
                                        },
                                        "&:hover": {
                                            backgroundColor: "#3d50b0",
                                            boxShadow: "none",
                                        },

                                        "&:active": {
                                            backgroundColor: "#3d50b0",
                                        },

                                        "&.Mui-focusVisible": {
                                            backgroundColor: "#3d50b0",
                                        }
                                    }}
                                    fullWidth
                                    disabled={disabled || loading}
                                    onClick={submit}
                                >
                                    로그인
                                </Button>
                            </div>
                            <div>
                                <Button
                                    variant="text"
                                    sx={{
                                        height: "52px",
                                        borderRadius: "13px",
                                        fontWeight: 500,
                                        fontFamily: "Apple_R",
                                        marginTop: "2px",
                                        boxShadow: "none !important",
                                        color: "#202632",
                                    }}
                                    fullWidth
                                    onClick={() => {
                                        props.history.push("/mobilefindpassword");
                                    }}
                                >
                                    비밀번호 찾기
                                </Button>
                            </div>

                        </div>

                    </div>
                    <div className={styles.buttonscontainer2} style={{
                        width: "100%"
                    }}>
                        <div style={{
                            width: "100%"
                        }}>
                            <Button
                                variant="outlined"
                                sx={{
                                    height: "52px",
                                    borderRadius: "13px",
                                    fontWeight: 500,
                                    fontFamily: "Apple_R",
                                    marginTop: "2px",
                                    boxShadow: "none !important",
                                    color: "#202632",
                                    borderColor: "#202632",
                                    //click했을때도 검은색 유지
                                    "&:hover": {
                                        borderColor: "black",
                                        backgroundColor: "#f5f5f5"
                                    },
                                    "&:active": {
                                        borderColor: "black",
                                        backgroundColor: "#e0e0e0"
                                    }
                                }}
                                fullWidth
                                onClick={() => {
                                    props.history.push("/signup2");
                                }}
                            >
                                수능선배가 처음이신가요? 간편가입하기
                            </Button>
                        </div>
                    </div>
                </div>
            </div>

            <IonLoading
                cssClass='my-custom-class'
                isOpen={showLoading}
                onDidDismiss={() => setShowLoading(false)}
                message={'잠시만 기다려주세요'}
            />
        </div>
    )
}

export default MobileLogin2;
